<template>
  <div class="modal-containuous-container" v-if="service">
    <sweet-modal ref="modal" overlay-theme="dark">
      <div class="modal-title">서비스 이용기간 연장</div>
      <div class="flex-center">
        <div style="width:451px">
          <div class="box-account">
            <div class="grid-row">
              <div class="grid-title">서비스명</div>
              <div class="grid-content flex-align" style="gap:0 12px">
                <div>{{ service.service_name }}</div>
              </div>
            </div>
            <div class="grid-row">
              <div class="grid-title">이용중인 상품</div>
              <div class="grid-content">
                <div v-for="(prod,pidx) in service.schedule.products" :key="`prod-${pidx}`"
                     style="text-align: left">[{{ prod.category_name }}] {{ prod.name }}</div>
              </div>
            </div>
            <div class="grid-row">
              <div class="grid-title">연장 기간</div>
              <div class="grid-content">{{ period }}</div>
            </div>
          </div>

          <div class="box-free">
            <div class="subtitle6">결제 금액</div>
            <div class="h6">{{ service.schedule.price | currencyNum }}<span class="body2">원</span></div>
          </div>

          <billing-form2 v-if="vForm" ref="form"></billing-form2>

          <ul>
            <li>이용기간은 바로 연장되며, 결제는 다음 결제예정일({{ datesFormat(service.schedule.next_date, 'date_3') }})에 진행됩니다.</li>
            <li>계속 진행하면 런치팩 서비스 약관에 동의하는 것으로 간주됩니다.<br>
              <a href="https://launchpack.co.kr/privacy" target="_blank">개인정보처리방침</a> - 개인정보 수집 및 공유에 사용자의 데이터를 처리하는 방식이 설명되어 있습니다.
            </li>
          </ul>

          <button class="button-continue button is-primary" @click="clickContinue">기간 연장하기</button>
        </div>
      </div>
    </sweet-modal>
  </div>
</template>

<script>
  import { SweetModal } from "sweet-modal-vue";
  import moment from 'moment';
  import BillingForm2 from "./BillingForm2";
  export default {
    name: "ModalContinuous",
    components: {
      BillingForm2,
      SweetModal
    },
    props: {
      service: {
        type: Object
      }
    },
    data() {
      return {
        vForm: false
      }
    },
    methods: {
      getMasterUrl(path) {
        return `${this.masterBackendUrl}serviceadmin/${this.$store.getters.admin.id}/launchpack/${path}`;
      },
      getMasterServiceUrl(path) {
        return this.getMasterUrl(`service/${this.$store.getters.masterService.service_id}/${path}`);
      },
      open() {
        this.vForm = true;
        setTimeout(()=>{
          this.$refs.modal.open();
        })
      },
      async clickContinue() {
        let param = {};
        if(this.$refs.form.vForm) {
          // 카드 등록 후 진행
          try {
            let res = await this.$axios.post(this.getMasterUrl(`card_bill/user/${this.$store.getters.masterService.service_id}`), this.$refs.form.value);
            if(res.data.result === 'error') {
              if(res.data.message.indexOf('CDAU1002')>-1) {
                this.toast(res.data.message.replace('[CDAU1002] ',''));
              } else {
                this.toast('카드 정보가 잘못 입력되었습니다.');
                Object.keys(this.$refs.form.$refs.form.err).forEach((key=>{
                  this.$refs.form.$refs.form.err[key].err = false;
                }));
                for(let item of [
                  { code: '3110', key: 'card_num' },
                  { code: '3115', key: 'pw' },
                  { code: '3119', key: 'ex' },
                  { code: '3131', key: 'birth' }
                ]) {
                  if(res.data.message.indexOf(item.code)>-1) {
                    this.$refs.form.$refs.form.err[item.key].err = true;
                  }
                }
              }
              return;
            }
            // 성공
            else {
              param['bill_id'] = res.data.bill_id;
            }

          } catch(err) {
            this.toast('등록에 실패하였습니다. 관리자에 문의하여 주십시오.');
            return;
          }
        }
        // 카드 기존꺼 선택한 경우
        else {
          param['bill_id'] = this.$refs.form.selectedBill.id;
        }

        this.$axios.post(this.getMasterServiceUrl('schedule'), param).then(res => {
          this.$refs.modal.close();
          this.vForm = false;
          this.$emit('continue');
        });
      }
    },
    computed: {
      period() {
        let start = moment(this.service.schedule.end_date).add(1,'days');
        let start_date = start.format('YYYY.MM.DD');
        let end = start.add(this.service.schedule.date_unit, 'month');
        return `${start_date} ~ ${end.format('YYYY.MM.DD')}`;
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import '~assets/css/lp_main'
  .modal-title
    font-size 22px
    font-weight 700
    margin-bottom 36px
    text-align center
  .box-account
    margin-top 12px
    padding 16px 28px
    background-color $gray4
    border-radius 8px
  .box-free
    margin-top 12px
    background-color $sub2
    color white
    padding 20px 28px
    border-radius 8px
    display flex
    align-items center
    justify-content space-between

  .grid-row
    display grid
    grid-template-columns 120px 1fr
    border-bottom 1px solid $gray1
    padding 12px 0
  .grid-row:last-child
    border-bottom 0
  .grid-title
    font-weight 500
    font-size 14px
  .grid-content
    font-size 14px

  .button-continue
    width 100%
    height 52px !important
    font-weight 500
    font-size 16px !important

  ul
    padding 20px
    padding-right 0
    font-weight normal
    font-size 13px
    line-height 20px
    color $sub2
  li
    list-style disc
  a
    color #08f

</style>
<style lang="stylus">
  .sweet-modal-overlay
    -webkit-perspective initial

  .modal-containuous-container
    .sweet-modal.is-alert
      width 800px
    .sweet-modal.is-alert .sweet-content
      padding 42px
</style>
